"use strict";

exports.__esModule = true;
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../utils");

var _PopoverContent = _interopRequireDefault(require("../Popover/PopoverContent"));

var _styled = require("./styled");

var _constants = require("./constants");

var _propTypes = require("./propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Tooltip =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(Tooltip, _Component);

  function Tooltip() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: Boolean(_this.props.defaultIsOpen)
    });

    _defineProperty(_assertThisInitialized(_this), "id", _this.props.id || "tooltip-" + (0, _utils.generateId)());

    _defineProperty(_assertThisInitialized(_this), "openTimer", void 0);

    _defineProperty(_assertThisInitialized(_this), "getTriggerProps", function (props) {
      if (props === void 0) {
        props = {};
      }

      return _objectSpread({}, props, {
        'aria-expanded': undefined,
        onBlur: (0, _utils.composeEventHandlers)(props.onBlur, _this.close),
        onFocus: (0, _utils.composeEventHandlers)(props.onFocus, _this.handleDelayedOpen),
        onMouseEnter: (0, _utils.composeEventHandlers)(props.onMouseEnter, _this.handleDelayedOpen),
        onMouseLeave: (0, _utils.composeEventHandlers)(props.onMouseLeave, _this.close),
        tabIndex: 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderTrigger", function () {
      var children = _this.props.children;
      var trigger = typeof children === 'string' ? (0, _core.jsx)(_styled.TriggerText, null, children) : children;

      var child = _react.Children.only(trigger);

      return (0, _react.cloneElement)(child, _this.getTriggerProps(child.props));
    });

    _defineProperty(_assertThisInitialized(_this), "getContentProps", function (props) {
      if (props === void 0) {
        props = {};
      }

      var content = _this.props.content;

      var _props = props,
          ignoreTabIndex = _props.tabIndex,
          restProps = _objectWithoutPropertiesLoose(_props, ["tabIndex"]);

      return _objectSpread({}, restProps, {
        'aria-live': 'polite',
        children: content,
        role: 'tooltip'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function (_temp) {
      var _ref = _temp === void 0 ? {} : _temp,
          props = _ref.props;

      return (0, _core.jsx)(_PopoverContent.default, _this.getContentProps(props));
    });

    _defineProperty(_assertThisInitialized(_this), "handleDelayedOpen", function (event) {
      _this.clearOpenTimer();

      var isOpen = _this.getControllableValue('isOpen');

      if (!isOpen) {
        _this.openTimer = global.setTimeout(function () {
          _this.open(event);
        }, _constants.DELAY_OPEN);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clearOpenTimer", function () {
      global.clearTimeout(_this.openTimer);
      _this.openTimer = null;
    });

    _defineProperty(_assertThisInitialized(_this), "open", function (event) {
      if (_this.isControlled('isOpen')) {
        _this.openActions(event);
      } else {
        _this.setState({
          isOpen: true
        }, function () {
          _this.openActions(event);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "openActions", function (event) {
      _this.props.onOpen && _this.props.onOpen(event);
    });

    _defineProperty(_assertThisInitialized(_this), "close", function (event) {
      _this.clearOpenTimer();

      if (_this.isControlled('isOpen')) {
        _this.closeActions(event);
      } else {
        _this.setState({
          isOpen: false
        }, function () {
          _this.closeActions(event);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "closeActions", function (event) {
      _this.props.onClose && _this.props.onClose(event);
    });

    _defineProperty(_assertThisInitialized(_this), "isControlled", function (prop) {
      return _this.props.hasOwnProperty(prop);
    });

    _defineProperty(_assertThisInitialized(_this), "getControllableValue", function (key) {
      return _this.isControlled(key) ? _this.props[key] : _this.state[key];
    });

    return _this;
  }

  var _proto = Tooltip.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.clearOpenTimer();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        disabled = _this$props.disabled,
        ignoreSubtitle = _this$props.subtitle,
        ignoreTitle = _this$props.title,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["children", "disabled", "subtitle", "title"]);

    if (disabled) {
      return children;
    }

    var popoverProps = _objectSpread({}, restProps, {
      children: this.renderTrigger(),
      focusTriggerOnClose: false,
      id: this.id,
      isOpen: this.getControllableValue('isOpen'),
      onClose: this.close,
      onOpen: this.open,
      content: this.renderContent
    });

    return (0, _core.jsx)(_styled.TooltipRoot, popoverProps);
  };

  return Tooltip;
}(_react.Component);

exports.default = Tooltip;

_defineProperty(Tooltip, "displayName", 'Tooltip');

_defineProperty(Tooltip, "defaultProps", {
  hasArrow: true,
  placement: _constants.PLACEMENT.bottom
});

Tooltip.propTypes = process.env.NODE_ENV !== "production" ? _propTypes.tooltipPropTypes : {};